import React, {useEffect, useRef, useState} from "react"
import * as Yup from "yup"
import {useSelector} from "react-redux"
import {useForm} from "react-hook-form"
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from "reactstrap"
import Switch from "react-bootstrap-switch";

// components
import WidgetLangs from "./_langs";
import {GenericButton} from "../../../components/buttons/customButtons";
import Separator from "../../../components/Separator";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import ModalFormTitle from "../../../components/genericComponents/ModalFormTitle";
import TranslateButton from "../../../components/buttons/TranslateButton";

// labels
import {PH_BACKGROUND, PH_CODE} from "../../../components/i18n/placeHolders"
import {LB_CODE, INTERNATIONAL, LB_STATUS, REQUIRED, LB_BACKGROUND} from "../../../components/i18n/i18n"
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";

// services
import {widgetService} from "../../../jwt/_services/landings/widgetService"

// utils
import {getStateByPath} from "../../../redux/selectors";

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import Icons from "./icons/Icons";
import ImagePicker from "../../../components/imagePickerComponents/ImagePicker";
import {widgetMediaService} from "../../../jwt/_services/landings/widgetMediaService";

const WidgetForm = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { udn, app, editMode, domainObject} = componentState?.data;

    const {fbDataBase} = app
    const translatableLangs = domainObject?.translatedLangs || []

    const [status, setStatus] = useState(domainObject?.status);
    const [langs, setLangs] = useState(domainObject?.langs || []);
    const [showModal, setShowModal] = useState(true)

    const modalRef = useRef(null);

    // Actualiza el formulario con los datos del objeto de dominio
    // Se utiliza posterior a la carga de imagenes desde ImagePicker ejecutando el metodo refresh()
    useEffect(() => {
        if (domainObject && domainObject.id && domainObject.langs) {
            reset({
                id: domainObject.id,
                code: domainObject?.code,
                background: domainObject?.background,
            })
            setLangs(domainObject.langs || []);
            setStatus(domainObject.status);
        }
    }, [ domainObject ]);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED ),
    });

    const { register, handleSubmit, reset, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            code: domainObject?.code,
            background: domainObject?.background,
        }
    });

    const onSubmit = (data, _) => {
        let dataRequest = {
            fbDataBase,
            item : {
                ...data,
                status: !!status,
                langs
            }
        };

        if (!editMode)
            genericIndexedActions.save(path, widgetService, dataRequest)
        else {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, widgetService, id, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.onClose()
    }

    const refreshObject = () => genericIndexedActions.get(path, widgetService, domainObject?.id, fbDataBase.id);


    return <Form onSubmit={ handleSubmit(onSubmit) }>
        <Card className={'card-modal'}>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <ModalFormTitle
                    domainObject={domainObject}
                    editMode={editMode}
                    udn={udn}
                />

                <div className={'top-right'}>
                    <GenericButton
                        style={'table'}
                        icon={'fa-save'}
                        toolTip={TT_SAVE}
                        permission={'add'}
                        type={'submit'}
                    />
                    {
                        editMode && <>
                            {/*<GenericButton*/}
                            {/*    style={'table'}*/}
                            {/*    toolTip={'Actualizar datos'}*/}
                            {/*    icon={'fa-refresh'}*/}
                            {/*    permission={'search'}*/}
                            {/*    onClick={refreshObject}*/}
                            {/*/>*/}
                            <GenericButton
                                style={'table'}
                                toolTip={TT_HISTORY}
                                icon={'fa-clock'}
                                permission={'search'}
                                onClick={showHistory}
                            />
                            <TranslateButton
                                item={domainObject}
                                service={widgetService}
                                path={path}
                            />
                        </>
                    }
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={closeForm}
                    />
                </div>
            </CardTitle>
            <CardBody className={'card-body-modal'}>
                <Row>
                    <Col>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label>{LB_CODE}</Label>
                                    <Input
                                        type="text"
                                        name="code"
                                        placeholder={PH_CODE}
                                        innerRef={register}
                                    />
                                    {errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label>{LB_BACKGROUND}</Label>
                                    <Input
                                        type="text"
                                        name="background"
                                        placeholder={PH_BACKGROUND}
                                        innerRef={register}
                                    />
                                    { errors.background && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.background?.message}</div>}
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label>{LB_STATUS}</Label>
                                    <br/>
                                    <Switch
                                        animate={true}
                                        offText={"No"}
                                        onText={"Si"}
                                        value={status}
                                        onChange={ () => setStatus(!status) }
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <CardTitle className="bg-light border-bottom p-3 mb-0">
                            <i className="fas fa-language mr-2"/>
                            { INTERNATIONAL }
                        </CardTitle>
                        <CardBody>
                            <WidgetLangs
                                langs={langs}
                                setLangs={setLangs}
                                translatableLangs={translatableLangs}
                            />
                        </CardBody>
                    </Col>
                    {
                        editMode && <Col>
                            <Row>
                                <Col md={12}>!
                                    <ImagePicker
                                        app={app}
                                        title={'Media'}
                                        className={'widget'}
                                        service={widgetService}
                                        baseMediaService={widgetMediaService}
                                        objectMedia={domainObject}
                                        afterUpload={refreshObject}
                                    />
                                </Col>
                                <Col md={12}>
                                    <br/>
                                    <br/>
                                    <Icons path={props.path} />
                                </Col>
                            </Row>
                        </Col>
                    }
                </Row>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ domainObject }
                />
            }
        </Card>
    </Form>
}
export default WidgetForm